import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';
import { QpxPill, QpxTooltip } from '@quipex/shared/ui';
import { selectedBuildingInfoSourcePresentation } from '../mapper';
import type { BuildingInfoSource } from '../models';

@Component({
    selector: 'qpx-building-info-source-indicator',
    imports: [QpxPill, QpxTooltip],
    templateUrl: './building-info-source-indicator.html',
    styleUrl: './building-info-source-indicator.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'inline-flex shrink-0 items-center',
    },
})
export class BuildingInfoSourceIndicator {
    //#region Inputs
    public readonly sources = input.required<readonly BuildingInfoSource[]>();
    public readonly compact = input(false);
    //#endregion

    //#region State
    protected readonly presentation = computed(() =>
        selectedBuildingInfoSourcePresentation(this.sources())
    );
    //#endregion
}
